import {
  Avatar,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  Stack,
  Typography,
  Zoom,
} from "@mui/material";
import { grey, red } from "@mui/material/colors";
import { useEffect, useState } from "react";

function Bin(props) {
  const [messages, setMessages] = useState([]);

  const deletedMessages = messages.filter((msg) => {
    return msg.deleted ? true : false;
  });

  useEffect(
    () => async () => {
      const response = await fetch(
        "http://127.0.0.1:8000/messenger/messages/",
        {
          mode: "cors",
          method: "GET",
        }
      );
      const fetcher = response.body.getReader();
      let data = [];
      let receivedLength = 0;
      while (true) {
        const { value, done } = await fetcher.read();

        if (done) {
          break;
        }

        data.push(value);
        receivedLength += value.length;
      }
      let chunksAll = new Uint8Array(receivedLength);
      let position = 0;
      for (let chunk of data) {
        chunksAll.set(chunk, position);
        position += chunk.length;
      }
      let result = new TextDecoder("utf-8").decode(chunksAll);

      let finalData = JSON.parse(result);
      setMessages(finalData);
      console.log(finalData);
    },
    []
  );


  const handleRestore = (id) => {
    const filteredMessages = messages.map((mesg) => {
      if (id === mesg.id) {
        mesg.deleted = false;
      }
      return mesg;
    });
    setMessages(filteredMessages);
    const params = {
      url: 'http://127.0.0.1:8000/messenger/messages/',
      method:'PATCH',
      params:{
        id:id,
        type:'restore'}
    };
    const data = apiLoader(params);
  };

  const handleFinalDelete = (id) => {
    const filteredMessages = messages.filter((mesg) => {
      if (id === mesg.id) {
        return false;
      }
      return true;
    });
    setMessages(filteredMessages);
    const params = {
      url: 'http://127.0.0.1:8000/messenger/messages/',
      method:'DELETE',
      params:{id:id}
    };
    const data = apiLoader(params);
    console.log(data);
    
  };

  return (
    <Zoom in={true} style={{ transitionDelay: "200ms" }}>
    <Stack><Typography variant="h6">Bin</Typography>
      <Divider variant="middle" />

      {deletedMessages.length>0 ? deletedMessages.map((message) => {
        return (
          <Card elevation={3} key={message.id} sx={{ mt: 1, mb: 1 }}>
            <CardHeader
              sx={{ bgcolor: red[500] }}
              avatar={<Avatar sx={{ bgcolor: grey[400] }}>B</Avatar>}
              title={<Typography>{message.date}</Typography>}
              subheader={
                <Typography variant="h6">From {message.label}</Typography>
              }
            />
            <CardContent>
              <Typography>{message.message}</Typography>
            </CardContent>
            <CardActions
              sx={{ display: "flex", justifyContent: "space-evenly" }}
            >
              <Button variant="outlined" onClick={() => handleRestore(message.id)}>
                Restore
              </Button>
              <Button
                variant="outlined"
                color="error"
                onClick={() => handleFinalDelete(message.id)}
              >
                Delete
              </Button>
            </CardActions>
          </Card>
        );
      }): <Box display={'flex'} justifyContent={'center'} mt={2}><Typography>Bin is empty</Typography></Box>}
    </Stack>
    </Zoom>
  );
}

export default Bin;


async function apiLoader(parameters){

  let results = {}
  let  params = parameters.params
  
const response = await fetch(
  parameters.url,
  {
    mode: "cors",
    method: parameters.method,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
    body: new URLSearchParams(params)      
  }
);

 results.status = response.status
const fetcher = response.body.getReader();
let data = [];
let receivedLength = 0;
while (true) {
  const { value, done } = await fetcher.read();

  if (done) {
    break;
  }

  data.push(value);
  receivedLength += value.length;
}
let chunksAll = new Uint8Array(receivedLength);
let position = 0;
for (let chunk of data) {
  chunksAll.set(chunk, position);
  position += chunk.length;
}
let result = new TextDecoder("utf-8").decode(chunksAll);

let finalData = JSON.parse(result);
results.data = finalData;
return results;
}